<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>
<script>
import axios from 'axios'
import wx from 'weixin-js-sdk'
import Common from './assets/js/common.js'
// var projectName = localStorage.getItem('projectName')
var isLocal = Common.getEvn()
var _local = window.location.href
var api = process.env.BASE_URL
var serviceType = localStorage.getItem('max_service_type')
var APPID
// if (projectName !== 'max') {
// localStorage.clear()
// }
if (isLocal === 'local') {
  // localStorage.setItem('max_userId', 12866)
  localStorage.setItem('max_userId', 426)
} else {
  localStorage.removeItem('max_userId')
  if (serviceType !== isLocal) {
    localStorage.clear()
    localStorage.setItem('max_service_type', isLocal)
  }
}

if (_local.indexOf('test') > -1) {
  APPID = 'wxed0e9a873577e363'
  // APPID = 'wx9e30c6207a34277f'
  localStorage.setItem('appId', APPID)
} else { // debug
  APPID = 'wx9e30c6207a34277f'
  // APPID = 'wxed0e9a873577e363'
  localStorage.setItem('appId', APPID)
}

Array.prototype.equals = function (array) {
  if (!array) return false
  if (this.length !== array.length) return false
  for (var i = 0, l = this.length; i < l; i++) {
    // Check if we have nested arrays
    if (this[i] instanceof Array && array[i] instanceof Array) {
      // recurse into the nested arrays
      if (!this[i].equals(array[i])) return false
    } else if (this[i] !== array[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false
    }
  }
  return true
}
export default {
  name: 'App',
  methods: {
    // 获取wxConfig所需要的配置项
    getWxConfig (_this) {
      let currentURL = encodeURIComponent(location.href.split('#')[0])
      // (currentURL)
          this.toast = this.$createToast({
          time: 0,
          txt: '加载中',
          mask: true
        }).show()
      if (Common.getEvn() === 'local') {
        axios.get('/mmc/api/wx_user/get_token/?url=' + currentURL)
        .then(this.getWxConfigSucc)
        .catch(this.getWxConfigError)
      } else {
        axios.get(api + '/mmc/api/wx_user/get_token/?url=' + currentURL)
        .then(this.getWxConfigSucc)
        .catch(this.getWxConfigError)
      }
    },
    getWxConfigSucc (res) {
      // alert(JSON.stringify(res.data))
      this.toast.hide()
      let result = res.data.result
      this.wxConfig(APPID, result.timestamp, result.nonceStr, result.signature, this)
    },
    getWxConfigError (res) {
      this.toast.hide()
    },
    wxConfig (_appId, _timestamp, _nonceStr, _signature, _this) {
      // alert('获取数据：' + _timestamp + '\n' + _nonceStr + '\n' + _signature)
      wx.config({
        beta: true,
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: _appId, // 必填，公众号的唯一标识
        timestamp: _timestamp, // 必填，生成签名的时间戳
        nonceStr: _nonceStr, // 必填，生成签名的随机串
        signature: _signature, // 必填，签名，见附录1
        jsApiList: ['checkJsApi', 'configWXDeviceWiFi', 'scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
      wx.error(function (res) {
        _this.toast = _this.$createToast({
          txt: '微信配置出错' + res.errMsg,
          type: 'txt'
        })
        _this.toast.show()
        localStorage.setItem('wx_err', 'yes')
        // alert('出错了：' + res.errMsg) // 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
      })
      wx.ready(function () {
        wx.checkJsApi({
          jsApiList: ['configWXDeviceWiFi', 'scanQRCode'],
          success: function (res) {}
        })
      })
    },
    handleOrientationChange (mql) {
      if (!mql.matches) {
        this.toast = this.$createToast({
          txt: '请使用竖屏模式浏览',
          type: 'txt'
        }).show()
      }
    },
    banFontSize () {
      if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
        handleFontSize()
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize)
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
        }
      }
      function handleFontSize () {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0})
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function () {
          WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0})
        })
      }
    }
  },
  created () {
    this.banFontSize()
    localStorage.removeItem('wx_err')
    this.getWxConfig(this)
    var mql = window.matchMedia('(orientation: portrait)')
    this.handleOrientationChange(mql)
    mql.addListener(this.handleOrientationChange)
  }
}
</script>

<style>
  body, input, textarea, button, select, pre, xmp, tt, code, kbd, samp{
    font-family: inherit;
  }
  .cube-dialog-btn_highlight{
    color: #334f5f!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue